<template>
    <div>
        <v-divider></v-divider>
        <v-subheader
            @click="open = !open"
        >
            <v-list-item-icon>
                <v-icon>
                    mdi-dog
                </v-icon>
            </v-list-item-icon>
            Dogs
            <v-spacer></v-spacer>
            <v-btn
                icon
            >
                <v-icon v-if="!open">
                    mdi-chevron-up
                </v-icon>
                <v-icon v-else>
                    mdi-chevron-down
                </v-icon>
            </v-btn>
        </v-subheader>
        <v-expand-transition>
            <div
                v-if="open"
            >
                <v-list-item
                    v-for="(dog, key) in dogs"
                    :key="key"
                >
                    <v-list-item-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            Race: {{dog.race}}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Shoulderheight: {{ dog.shoulderheight }} cm <br />
                            Bodyweight: {{ dog.bodyWeight }} kg
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
    export default {
        props: {
            dogs: {
                type: Array,
                required: true,
            },
        },
        data: () => ({
            open: false,
        }),
    }
</script>

<style lang="scss" scoped>
    .v-subheader {
        cursor: pointer;
        height: 56px;
    }
</style>
